import { Button, Card, Collapse, Input, Modal, Select, message } from "antd";
import "./AutoCrawling.css";
import axios from "axios";
import { DownloadOutlined } from "@ant-design/icons";
import fileDownload from "js-file-download";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  GetACFailedClients,
  GetAutoCrawlStatus,
  Get_ReConsolidation_Clients
} from "../../redux/TimeCardsRedux/TimeCardsActions";

const AutoCrawling = () => {

  //Dispatcher
  const dispatch = useDispatch();

  const jwtToken = Cookies.get("jwt_token");

  //Download AutoCrawled Reports
  const AutoCrawlUser = "AutoCrawling_User";

  const DownloadAutoCrawledFiles = async () => {
    console.log("Downloading");

    const url =
      `${process.env.REACT_APP_BASE_URL}Home/DownloadZipFile?filename=` +
      AutoCrawlUser;
    const config = {
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
      responseType: "blob",
    };
    const response = await axios.get(url, config);
    fileDownload(response.data, "AutoCrawledFiles.zip");
  };

  //Get AutoCrawl Status
  const AutoCrawl = useSelector((state) => state.timecardsReducer);

  //AutoCrawl Button Background Color
  const BGColorGrey ="#EFEFEF";
  const BGColorBlue = "#003A8C";
  const FontColorWhite ="#FFFFFF";
  const FontColorBlue ="#003A8C";
  return (
    <>
      <div className="Accordion-header">
        <div className="autocrawl-action-elements">
          <div className="vms-batchstatus">
            {/*  vms completed*/}
            <div className="vms-processed">
              <label className="form-label">Total VMS Processed :</label>
              <label className="label-value">
                {AutoCrawl.VmsCompletedCount}
              </label>
            </div>
            <br />

            {/* batch status */}
            <div className="batch-status">
              <label className="form-label">Batch Status :</label>
              <label className="label-value">{AutoCrawl.BatchLabel}</label>
            </div>
            <br />
          </div>

          {/*Crawling Action ELements */}
          <div className="crawling-block">
            <div style={{ width: "50%" }}>
              <Button
                onClick={() => {dispatch(GetAutoCrawlStatus()); dispatch(Get_ReConsolidation_Clients());}}
                style={{ marginRight: "400px", background: "#003A8C", color:"#FFFFFF" }}
              >
                Auto Crawl
              </Button>
            </div>
            <div style={{ width: "50%" }}>
              <Button
                style={{ background: AutoCrawl.EnableAutoCrawl?BGColorGrey:BGColorBlue, color: AutoCrawl.EnableAutoCrawl?FontColorBlue:FontColorWhite }}
                disabled={AutoCrawl.EnableAutoCrawl}
                onClick={() => DownloadAutoCrawledFiles()}
              >
                <span>Download AutoCrawl Reports</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AutoCrawling;

